<script lang="ts">
	import qs from 'qs';
	import StrapiContent from './StrapiContent.svelte';
	import StrapiImage from './StrapiImage.svelte';
	import { trackLink } from './utils/mixpanel';

	interface Props {
		position: ArticleAdPosition;
		category?: string;
		themes?: BaseTheme[];
	}

	let { position, category = '', themes = [] }: Props = $props();

	async function getArticleAd(position: ArticleAdPosition, themes: BaseTheme[]) {
		const params = qs.stringify({
			position,
			...(themes.length
				? { themes: themes.map((theme) => theme.uid) }
				: category
					? {
							category
						}
					: {})
		});

		const articleAds = await fetch(`/api/article-ads?${params}`).then(
			(res) => res.json() as unknown as ArticleAd[]
		);

		if (
			[
				'Interest Maximiser - All',
				'Interest Maximiser - Savings',
				'Interest Maximiser - Priority Banking',
				'Interest Maximiser - Fixed Deposit',
				'Interest Maximiser - Cash Management'
			].includes(position) &&
			articleAds.length === 0
		) {
			const fallbackAds = await fetch(
				`/api/article-ads?${qs.stringify({
					position: 'Interest Maximiser - All'
				})}`
			).then((res) => res.json() as unknown as ArticleAd[]);
			return fallbackAds[0];
		}

		if (!articleAds.length) {
			setTimeout(() => {
				window.dianomiReloadContext!();
			}, 1000);
		}

		return articleAds[0];
	}

	function getType(position: ArticleAdPosition) {
		if (position === 'Before second H2') {
			return 'in-content-ad-top';
		} else if (position === 'Before last H2') {
			return 'in-content-ad-bottom';
		} else if (position === 'Before fourth H2') {
			return 'in-content-ad-mid';
		} else {
			return 'in-content-ad-im';
		}
	}
</script>

{#await getArticleAd(position, themes) then articleAd}
	{#if articleAd?.cta}
		{@const {
			cta: { title, description, primaryActionLabel, primaryActionUrl },
			provider,
			cover
		} = articleAd}
		{#if articleAd.isAd}
			<div class="my-6">
				<p class="text-gray-mid mx-auto mb-1 w-full text-center">
					<span class="small-bold">Ad</span> <span class="small-regular"> • {provider}</span>
				</p>
				<section class="mx-auto flex justify-center">
					<a
						onclick={trackLink}
						data-content={provider}
						data-type={getType(articleAd.position)}
						href={primaryActionUrl}
						class="element-visibility"
					>
						<StrapiImage {cover} class="w-full" />
					</a>
				</section>
			</div>
		{:else}
			<section
				class="section-my bg-blue-light mx-auto flex max-w-screen-md flex-col items-center rounded-2xl p-6 text-center"
			>
				<header class="h3 mb-3 flex items-start justify-center gap-2">
					{title}
				</header>
				<p class="card-regular mb-3">
					<StrapiContent content={description} />
				</p>
				<div class="mb-3">
					<StrapiImage {cover} class="w-full" />
				</div>
				<div class="flex justify-center">
					<a
						onclick={trackLink}
						data-content={provider}
						data-type={getType(articleAd.position)}
						href={primaryActionUrl}
						class="element-visibility btn btn-primary">{primaryActionLabel}</a
					>
				</div>
			</section>
		{/if}
	{:else}
		<div class="dianomi_context section-my" data-dianomi-context-id="3850"></div>
	{/if}
{/await}

<style lang="postcss">
	@reference '../app.css';

	.btn.btn-primary {
		@apply text-white-pure no-underline;
	}
</style>
